import VideoComp from "../videoComp/videoComp";
import ShopComp from "../shopComp/shopComp";
import ImgComp from "../imgComp/imgComp";
import Navigation from "../navigation/navigation";

//ASSETS
import pear from "../../videos/pear.mp4";

import Ring_2 from "../shopComp/images/img2.webp";
import img1 from "../../images/shopComp/comp2/img1.webp";
import img2 from "../../images/shopComp/comp2/img2.webp";
import img3 from "../../images/shopComp/comp2/img3.webp";
import img4 from "../../images/shopComp/comp2/img4.webp";

import Img_1 from "../../images/imgComp/imgComp2.webp";
import imgBg2 from "./images/bgs/pear.webp";
export default function SecondComp() {
  return (
    <>
      {/* <div className="allow-scroll demo"> */}
      {/* <Navigation /> */}

      <VideoComp
        id={2}
        idHeader={"the pear"}
        header={"Dovada măiestriei supreme "}
        text={
          <p>
            Îmbinând elemente ale tăieturii tip Marquise cu detalii ale celei
            ovale, <b>Pear Cut</b> sau tăietura tip lacrimă dă contur unui
            rafinament inedit. Liniile care sculptează baza rotundă se reunesc
            într-un singur punct și îi conferă grația și forma unică adorată de
            către iubitorii de bijuterii.
          </p>
        }
        // videoBg={imgBg2}
        videoBg={<img className="img-2" src={imgBg2} alt="" />}
        vidLink={pear}
        href={
          "https://www.teilor.com/diamond-platinum-engagement-ring-with-1-2ct-diamond-and-0-373ct-diamonds-119557.html"
        }
        buttonText={"View the ring"}
      />
      <ShopComp
        ring_1={img1}
        href_1={
          "https://www.teilor.ro/inel-din-aur-alb-de-18k-cu-diamant-de-0-1ct-si-diamante-de-0-16ct-33159.html"
        }
        ring_2={img2}
        href_2={
          "https://www.teilor.ro/lant-cu-pandant-din-aur-alb-de-18k-cu-diamant-de-0-06ct-si-diamante-de-0-1ct-117630.html"
        }
        ring_3={img3}
        href_3={
          "https://www.teilor.ro/cercei-din-aur-alb-de-18k-cu-diamante-de-0-3ct-112000.html"
        }
        ring_4={img4}
        href_4={
          "https://www.teilor.ro/inel-de-logodna-din-aur-alb-de-18k-cu-diamant-de-0-4ct-si-diamante-de-0-09ct-100255.html"
        }
        // mainLink={"https://www.teilor.ro/perpetual-love.html"}
      />

      <ImgComp
        img={Img_1}
        bgProp={"shape-2-bg"}
        // header={
        //   <>
        //     Arată cine ești și fii gata să strălucești. <br />
        //     <span>
        //       Răsfață-te cu bijuteriile care vorbesc despre tine. .
        //     </span>{" "}
        //     RING YOURSELF.
        //   </>
        // }
        // shape={<img className="shape-2" src={Svg_2}></img>}
        rightText1={<span style={{ color: "#797979" }}>Exuberantă</span>}
        rightText2={<span style={{ color: "#D30819" }}>Trendsetter</span>}
        leftText1={<span style={{ color: "#D00717" }}>Originală</span>}
        leftText2={<span style={{ color: "#484848" }}>Hotărâtă</span>}
        mainLink={"https://www.teilor.com/perpetual-love.html"}
      />
      {/* </div> */}
    </>
  );
}
